import React from "react";
import _validator from "modules/validator";
import MyInput from "components/controls/MyInput";
import {
  PASSWORD_UPDATE_SUCCESS
} from "constants/constants";
import _notification from "modules/notification";
import _authService from "modules/AuthService";
import Button from "components/controls/Button";
import { routes } from 'routes/Routes';
import PublicFooter from "../components/Footer/PublicFooter";
import Text, { resolveText } from "components/Text/Text";
import { getCurrentLocale, getCurrentDisplayMode } from "modules/LanguageContext";

// Stage 3.9 (Task 2/5): see ResetPassword.jsx's identical helper comment — a class component's methods
// run outside React's render cycle and can't call the useLanguage() hook.
function tr(key) {
  return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class SetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.token = this.props.match.params.token;
    this.state = {
      newPassword: "",
      newPasswordState: "",
      newPasswordError: "",
      confirmPassword: "",
      confirmPasswordState: "",
      confirmPasswordError: ""
    };
  }

  onTextChange = ({ target: { name, value } }) => {
    switch (name) {
      case "newPassword":
        if (_validator.verifyBlank(value)) {
          if (_validator.verifyPassword(value)) {
            this.setState({
              [name + "State"]: "success",
              [name + "Error"]: ""
            });
          } else {
            this.setState({
              [name + "State"]: "error",
              [name +
                "Error"]: tr("passwordCommon.passwordComplexity")
            });
          }
          if (
            this.state.confirmPassword != "" &&
            value !== this.state.confirmPassword
          ) {
            this.setState({
              confirmPasswordState: "error",
              confirmPasswordError:
                tr("passwordCommon.passwordsDoNotMatch")
            });
          } else if (this.state.confirmPassword != "") {
            this.setState({
              confirmPasswordState: "success",
              confirmPasswordError: ""
            });
          }
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: tr("passwordCommon.pleaseEnterNewPassword")
          });
        }
        break;
      case "confirmPassword":
        if (_validator.verifyBlank(value)) {
          this.setState({
            [name + "State"]: "success",
            [name + "Error"]: ""
          });
          if (this.state.newPassword !== value) {
            this.setState({
              [name + "State"]: "error",
              [name + "Error"]: tr("passwordCommon.passwordsDoNotMatch")
            });
          }
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: tr("passwordCommon.pleaseEnterConfirmPassword")
          });
        }
        break;

      default:
        this.setState({ [name + "State"]: "success" });
    }
    this.setState({ [name]: value.trim() });
  };

  handlePasswordChange = async ev => {
    ev.preventDefault();
    if (
      this.state.newPasswordState === "success" &&
      this.state.confirmPasswordState === "success"
    ) {
      const params = {
        body: {
          password: this.state.newPassword
        }
      };
      try {
        const response = await _authService.setPassword(params, this.token);
        if (response.data.isSuccess == true) {
          _notification.showMessage("success", PASSWORD_UPDATE_SUCCESS);
          this.setState({
            newPassword: "",
            newPasswordState: "",
            newPasswordError: "",
            confirmPassword: "",
            confirmPasswordState: "",
            confirmPasswordError: ""
          });
        } else {
          _notification.showMessage("error", response.data.message);
        }
      } catch (e) {
      
      }
    } else {
      if (this.state.newPasswordState === "") {
        this.setState({
          newPasswordState: "error",
          newPasswordError: tr("passwordCommon.pleaseEnterNewPassword")
        });
      }
      if (this.state.confirmPasswordState === "") {
        this.setState({
          confirmPasswordState: "error",
          confirmPasswordError: tr("passwordCommon.pleaseEnterConfirmPassword")
        });
      }
    }
  };

  render() {
    return (
      <>
      <form
        style={{ height: '100vh' }}
        onSubmit={this.handlePasswordChange}
        className="d-flex ml-3 mr-3"
      >
        <div className="login-form-wrap position-relative w-100 align-items-center m-auto  form-wrap d-flex align-items-center justify-content-center">
          <div className="login-form-inner-wrap w-100 d-flex align-items-center justify-items-center flex-column">
            <div className="row">
              <h5 className="color-secondary"><Text k="setPassword.heading" /></h5>
              <div className="login-sec mt-3 w-100">
                {/* Stage 3.8: for -> htmlFor (raw HTML attribute, invalid in JSX). */}
                <label htmlFor="newPassword"><Text k="passwordCommon.newPasswordLabel" /></label>
                <MyInput
                  id="newPassword"
                  wrapClass="mt-2"
                  type="password"
                  placeholder="********"
                  key="newPassword"
                  name="newPassword"
                  value={this.state.newPassword}
                  onChange={this.onTextChange}
                  isRequired={true}
                  errorState={this.state.newPasswordState}
                  errorMessage={this.state.newPasswordError}
                />

                <label htmlFor="confirmPassword"><Text k="passwordCommon.confirmPasswordLabel" /></label>
                <MyInput
                  id="confirmPassword"
                  wrapClass="mt-2"
                  type="password"
                  placeholder="********"
                  key="confirmPassword"
                  name="confirmPassword"
                  value={this.state.confirmPassword}
                  onChange={this.onTextChange}
                  onBlur={this.onTextChange}
                  isRequired={true}
                  errorState={this.state.confirmPasswordState}
                  errorMessage={this.state.confirmPasswordError}
                />
              </div>

              <div className="forget-sec w-100 text-center">
                <Button
                  type="submit"
                  className="button-global button-primary mb-3 w-100"
                  value={<Text k="setPassword.submitButton" />}
                ></Button>
                <a href="" tabIndex="-1" onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.login.path) }} className="d-block m-t-15 label underline colorWhite">
                  <Text k="passwordCommon.goToLogin" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </form>
      <PublicFooter />
      </>
    );
  }
}

export default SetPassword;
